// Pemeriksaan anti-bot Cloudflare Turnstile untuk form login (pola sama dengan ViSight TurnstileWidget).
// Mode `interaction-only`: widget tersembunyi dan hanya muncul bila Cloudflare butuh interaksi. Teks status
// `aria-live` jadi umpan balik utama. Token berlaku SEKALI: induk memasang `key` baru dan mengosongkan token setelah
// tiap percobaan login supaya widget dibuat ulang dan token baru terbit. Site key (publik) dari VITE_TURNSTILE_SITE_KEY saat build;
// kosong = widget tidak dirender, token kosong terkirim dan server (gagal-tertutup) menolak login.
import { useEffect, useRef, useState } from 'react';

const SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '';

export const turnstileAktif = SITE_KEY !== '';

let muatSkrip = null;

function pastikanSkrip() {
  if (window.turnstile) return Promise.resolve();
  muatSkrip ??= new Promise((selesai, gagal) => {
    const s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    s.async = true;
    s.onload = () => selesai();
    s.onerror = () => {
      muatSkrip = null; // izinkan coba lagi pada render berikutnya
      gagal(new Error('skrip Turnstile gagal dimuat'));
    };
    document.head.appendChild(s);
  });
  return muatSkrip;
}

const PESAN = {
  memeriksa: 'Memeriksa keamanan koneksi...',
  siap: 'Pemeriksaan keamanan selesai.',
  galat: 'Pemeriksaan keamanan gagal dimuat. Periksa koneksi atau pemblokir skrip, lalu muat ulang halaman.',
};

// onToken harus stabil (setState); dipanggil dengan '' saat token hilang.
export default function TurnstileWidget({ onToken }) {
  const wadah = useRef(null);
  const [status, setStatus] = useState('memeriksa');

  useEffect(() => {
    if (!turnstileAktif) return undefined;
    let batal = false;
    let id;
    pastikanSkrip()
      .then(() => {
        if (batal || !wadah.current || !window.turnstile) return;
        id = window.turnstile.render(wadah.current, {
          sitekey: SITE_KEY,
          language: 'id',
          appearance: 'interaction-only',
          callback: (token) => { onToken(token); setStatus('siap'); },
          'expired-callback': () => { onToken(''); setStatus('memeriksa'); },
          'error-callback': () => { onToken(''); setStatus('galat'); },
        });
      })
      .catch(() => setStatus('galat'));
    return () => {
      batal = true;
      if (id) window.turnstile?.remove(id);
    };
  }, [onToken]);

  if (!turnstileAktif) return null;

  return (
    <div role="group" aria-label="Pemeriksaan keamanan" className="w-full mt-1 mb-1">
      <div ref={wadah} />
      <p
        role="status"
        aria-live="polite"
        className="text-[10px] font-mono"
        style={{ color: status === 'galat' ? '#ff2d55' : 'var(--text-dim)' }}
      >
        {PESAN[status]}
      </p>
    </div>
  );
}
